"use strict";
/** Orders an event's markets for the picker, per the venue's `marketOrder` capability. */
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderEventMarkets = orderEventMarkets;
const market_categories_1 = require("./market-categories");
function orderEventMarkets(markets, order) {
    if (order === "type-then-title") {
        return [...markets].sort((a, b) => (0, market_categories_1.coarseRank)(a.marketCoarseType) - (0, market_categories_1.coarseRank)(b.marketCoarseType) ||
            a.title.localeCompare(b.title));
    }
    // Shortest id first: simpler markets with fewer options lead (owner-confirmed intent).
    return [...markets].sort((a, b) => a.id.length - b.id.length);
}
